module.exports = __webpack_public_path__ + "img/model_48_ug.5db8a87e.jpg";